import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export default function isJunkEmailEnabledByAdmin() {
    return !!getUserConfiguration().SegmentationSettings.JunkEMail;
}
//# sourceMappingURL=isJunkEmailEnabledByAdmin.js.map